var wavAudio = new Audio();
var bgmAudio = new Audio();

bgmAudio.volume = 0.5;

function WavSoundEffect(effect, bgm, type) {

        if(type === 'hover') { 
            bgmAudio.pause();
            wavAudio.src = effect;
            wavAudio.play();
            return;
        }

        if(type === 'click' && bgmAudio.paused === false) { 
            wavAudio.src = '/wav/_archer_hit.wav';
            wavAudio.play();
            bgmAudio.pause();
            return;
        }


        if(type === 'click' && bgmAudio.paused === true) {
            bgmAudio.src = bgm;
            wavAudio.src = '/wav/clicragk.wav';
            wavAudio.play();
            setTimeout(() => bgmAudio.play(),1000);

            return;
        }
}

export {WavSoundEffect};